




















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Step, Steps } from './Step';

@Component
export default class CartPageStep extends Vue {
  @Prop({ required: true })
  public thisStep: number;

  @Prop({ required: true })
  public currentStep: number;

  @Prop({ required: false, default: '/my/shopping-cart' })
  public link: string;

  get active() {
    return this.currentStep >= this.thisStep;
  }

  get done() {
    return this.currentStep > this.thisStep;
  }

  get icon() {
    return Steps.getIcon(this.thisStep);
  }

  get name() {
    return Steps.getName(this.thisStep);
  }

  get isLast() {
    return Steps.isLast(this.thisStep);
  }

  get showLink() {
    return Steps.isFirst(this.thisStep) && this.currentStep === Step.DELIVERY;
  }

  public findClasses() {
    const classes = [];
    if (this.active) {
      classes.push('active');
    }
    if (this.done || (this.active && this.isLast)) {
      classes.push('done');
    }
    if (this.isLast) {
      classes.push('last');
    }
    return classes.join(' ');
  }
}
